import { useState } from 'react'

import { useDisclosure } from '@chakra-ui/react'

import i18n from '~/i18n'
import MemberDetailView from '~/pages/Members/components/MemberDetail'
import MfaResetModal from '~/pages/Members/components/MfaResetModal'
import SuspendModal from '~/pages/Members/components/SuspendModal'
import UnlockModal from '~/pages/Members/components/UnlockModal'
import { MemberPageHeader } from '~/pages/Members/components/layouts/Header'
import { MemberPageInnerLayout } from '~/pages/Members/components/layouts/Inner'
import { MemberDetailRoute } from '~/routes/_authenticated/members/$memberId'

import { useMember } from './hooks/useMember'

export const MemberDetail: React.FC = () => {
  const memberId = MemberDetailRoute.useParams().memberId
  const member = useMember(memberId)
  const mfaResetDisclosure = useDisclosure()
  const unlockDisclosure = useDisclosure()
  const suspendDisclosure = useDisclosure()
  const [suspendMode, setSuspendMode] = useState<'suspend' | 'unsuspend'>(
    'suspend',
  )
  const onSuspend = (): void => {
    setSuspendMode('suspend')
    suspendDisclosure.onOpen()
  }
  const onUnsuspend = (): void => {
    setSuspendMode('unsuspend')
    suspendDisclosure.onOpen()
  }
  const isEnglish = i18n.language === 'en'
  const displayName = isEnglish
    ? member.englishName || member.name
    : member.name

  return (
    <MemberPageHeader
      breadcrumbItems={[
        {
          label: member.name,
        },
      ]}
    >
      <MemberPageInnerLayout>
        <MemberDetailView
          member={member}
          onResetMfa={mfaResetDisclosure.onOpen}
          onUnlock={unlockDisclosure.onOpen}
          onSuspend={onSuspend}
          onUnsuspend={onUnsuspend}
        />
      </MemberPageInnerLayout>

      <MfaResetModal
        name={displayName}
        memberId={member.id}
        open={mfaResetDisclosure.open}
        onClose={mfaResetDisclosure.onClose}
        onSuccess={mfaResetDisclosure.onClose}
      />

      <UnlockModal
        memberId={member.id}
        open={unlockDisclosure.open}
        onClose={unlockDisclosure.onClose}
        onSuccess={unlockDisclosure.onClose}
      />

      <SuspendModal
        memberId={member.id}
        mode={suspendMode}
        open={suspendDisclosure.open}
        onClose={suspendDisclosure.onClose}
        onSuccess={suspendDisclosure.onClose}
      />
    </MemberPageHeader>
  )
}
